<script setup>
import ProfileHeader from "./ProfileHeader.vue";
import { useAuth } from "./useAuth";

import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

// Создание реактивных переменных с начальными пустыми значениями
const firstName = ref("");
const lastName = ref("");
const patronymic = ref("");
const email = ref("");
const password = ref("");
const passwordNew = ref("");
const showPassword = ref(false);
const showPassword2 = ref(false);

const isEditing = ref(false);

// Достаем статус авторизации и функцию выхода
const { logout } = useAuth();

const handleLogout = () => {
  logout(); // Удаляем токен и меняем статус
  router.push("/"); // Выкидываем на страницу входа
};

// Инициализация роутера
const router = useRouter();

async function loadProfile() {
  const token = localStorage.getItem("token");
  // Проверка если токена нет, то мы не делаем лишний запрос на сервер.
  if (!token) {
    console.error("Токен авторизации отсутсвует");
    return;
  }
  try {
    const response = await fetch("/api/profile", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const data = await response.json();

      // Отображаем данные для фронтенда
      // Записываем полученные данные в реактивные переменные
      // Внутри блока <script> к значени ref нужно обращаться через .value!
      firstName.value = data.first_name;
      lastName.value = data.last_name;
      patronymic.value = data.sur_name;
      email.value = data.email;
    } else {
      console.error("Ошибка получения профиля:", response.status);
    }
  } catch (error) {
    console.error("Ошибка сети:", error);
  }
}

// Вызываем функцию  при отрисовке компонента (Аналог DOMContentLoaded)
onMounted(() => {
  loadProfile();
});

// Функция только для обработки нажатия на кнопки внизу формы
async function handleProfileSumbit() {
  // Если поля заблокированы -> просто разблокируем их
  if (!isEditing.value) {
    isEditing.value = true;
    return; // Выходим из функции
  }

  // Если поля уже разблокированы значит юзер ввел данные и хочет сохранить
  const token = localStorage.getItem("token");
  try {
    // Здесь будет запрос на ОБНОВЛЕНИЕ данных (например, POST или PUT)
    const response = await fetch("api/profile/update", {
      method: "PUT", // Метод для обновления
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        first_name: firstName.value,
        last_name: lastName.value,
        sur_name: patronymic.value,
        email: email.value,
        current_password: password.value,
        new_password: passwordNew.value,
      }),
    });
    const data = await response.json();
    if (response.ok) {
      alert("Данные успешно сохранены!");
      // Блокируем поля обратно после сохранения
      isEditing.value = false;
      password.value = "";
      passwordNew.value = "";
    } else {
      alert("Ошибка: " + data.message);
    }
  } catch (error) {
    console.error("Ошибка при сохранении:", error);
  }
}
</script>

<template>
  <!-- Обертка: во Vue лучше иметь ОДИН корневой элемент внутри <template> -->
  <div class="flex flex-col">
    <ProfileHeader />
    <div class="flex-1 flex w-full bg-white py-10">
      <!-- prettier-ignore -->
      <div class="flex flex-col w-full max-w-[1685px] mx-auto px-4 sm:px-14 lg:px-16">
        <div class="text-center bg-[#F3F3F3] rounded-2xl p-6
        sm:p-12 lg:p-20">
          <div class="flex flex-col lg:flex-row justify-between items-start gap-2 w-full">
            <div class="flex flex-col text-left w-full lg:max-w-[300px]">
              <div class="flex items-center gap-3 mb-2">
                <svg class="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                <h2 class="text-2xl font-semibold text-black">Учетные данные</h2>
              </div>
              <p class="text-gray-600 text-sm mb-2">Ваш статус: пользователь</p>
              <p class="font-standart text-black">Привет {{ firstName }} {{ lastName }}</p>
            </div>
            
            <div class="flex flex-col w-full max-w-md gap-4">
              <input
                type="text"
                :disabled = "!isEditing"
                v-model="firstName"
                placeholder="Имя"
                class="w-full max-w-md p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all
                disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                required
              >
              <input
                type="text"
                :disabled = "!isEditing"
                v-model="lastName"
                placeholder="Фамилия"
                class="w-full max-w-md p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all
                disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                required
              >
              <input
                type="text"
                :disabled = "!isEditing"
                v-model="patronymic"
                placeholder="Отчество"
                class="w-full max-w-md p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all
                disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                required
              >
              <input
                type="email"
                :disabled = "!isEditing"
                v-model="email"
                placeholder="Электронная почта"
                class="w-full max-w-md p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all
                disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                required
              >
              
              <div class="relative w-full max-w-md">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  :disabled = "!isEditing"
                  v-model="password"
                  placeholder="Старый пароль"
                  class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                  focus:outline-none focus:border-gray-500 focus:ring-1 focus-ring-gray-500 transition-all
                  disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                >

                <button 
                  type="button" 
                  :disabled = "!isEditing"
                  @click="showPassword = !showPassword"
                  class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center 
                  mr-4 text-gray-400 hover:text-gray-600 focus:outline-none"
                >
                  <span class="text-lg leading-none cursor-pointer">{{ showPassword ? '👁️' : '👁️‍🗨️' }}</span>
                </button>
              </div>
              <div class="relative w-full max-w-md">
                <input
                  :type="showPassword2 ? 'text' : 'password'"
                  :disabled = "!isEditing"
                  v-model="passwordNew"
                  placeholder="Новый пароль"
                  class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
                  focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all
                  disabled:bg-gray-200 disabled:text-gray-500 disabled:border-transparent"
                  required
                >

                <button
                  :disabled = "!isEditing"
                  type="button"
                  @click="showPassword2 = !showPassword2"
                  class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center
                  mr-4 text-gray-400 hover:text-gray-600 focus:outline-none"
                  >

                  <span class="text-lg leading-none cursor-pointer">{{ showPassword2 ? '👁️' : '👁️‍🗨️' }}</span>
                </button>
              </div>
              <button
                @click="handleProfileSumbit"
                
                type="button"
                class="w-full bg-black text-white font-medium p-4 rounded-xl mt-2 hover:bg-gray-800 transition-colors"
                >
                {{ isEditing ? 'Сохранить изменения' : 'Редактировать данные' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-2">
      <a class="text-[#8888] font-bold cursor-pointer" @click="handleLogout">
        Выйти
      </a>
    </div>
    <!-- <div class="text-black">
      <p>Footer</p>
    </div> -->
  </div>
</template>
